import React from 'react';
import Modal from '../Modal';
import { Client } from '../../types/weighing';
import { ExclamationTriangleIcon, TrashIcon } from '@heroicons/react/24/outline';

interface DeleteClientModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  client: Client;
}

const DeleteClientModal: React.FC<DeleteClientModalProps> = ({ isOpen, onClose, onConfirm, client }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Supprimer le client" size="md">
      <div className="space-y-6">
        {/* Icône d'avertissement */}
        <div className="flex justify-center">
          <div className="p-3 bg-red-100 rounded-full">
            <ExclamationTriangleIcon className="h-8 w-8 text-red-600" />
          </div>
        </div>

        {/* Message de confirmation */}
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Êtes-vous sûr de vouloir supprimer ce client ?
          </h3>
          <p className="text-sm text-gray-500">
            Cette action est irréversible et supprimera définitivement le client et toutes ses données associées.
          </p>
        </div>

        {/* Informations du client à supprimer */}
        <div className="bg-gray-50 rounded-lg p-4">
          <h4 className="text-sm font-medium text-gray-700 mb-3">Client à supprimer :</h4>
          <div className="text-sm text-gray-600 space-y-1">
            <p><span className="font-medium">Nom :</span> {client.nom}</p>
            <p><span className="font-medium">Type :</span> {client.type}</p>
            <p><span className="font-medium">Secteur :</span> {client.secteur}</p>
            <p><span className="font-medium">Téléphone :</span> {client.telephone}</p>
            {client.email && <p><span className="font-medium">Email :</span> {client.email}</p>}
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center space-x-2"
          >
            <TrashIcon className="h-4 w-4" />
            <span>Supprimer définitivement</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteClientModal;
